import { Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import './top_section.css'
export default function Top_section_OPC(){
    return(
        <Grid container>
        <Grid container className="cont_top_OPC">
           <Container> 
        <Grid container>
            <Grid item sm={12} xs={12}>
                <Typography className="top_OPC_head">
                    ONE PERSON COMPANY
                </Typography>
            </Grid>

        </Grid>
        <Grid container >
            <Grid item sm={12} xs={12}>
                <Typography className="top_OPC_text">
                A Game Changer   
                             </Typography>
            </Grid>
        </Grid>
        </Container>
        </Grid>
        </Grid>
    )
}